<div class="ibox-content">
    <form [formGroup]="form">
      <div class="form-group row">
        <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
        <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
      </div>
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="personal" name="personal" type="text" class="form-control" />
      </div>
      <div class="row panel panel-warning" *ngIf="!disabledEditing">
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
          </div>
        </div>
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label font-bold">Clase Documento</label>
          <comboTools [list]=clasesDocList
                      selected='claseDocumento'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Clase de Documento'></comboTools>
          <div *ngIf="registerFormControl.claseDocumento.invalid && (registerFormControl.claseDocumento?.dirty || registerFormControl.claseDocumento?.touched || submitted)" class="text-danger">
            La Clase de Documento es Requerida
          </div>
        </div>
        <div class="col-md-6">
          <label class=" col-form-label font-bold">Nro. Documento</label>
          <input formControlName="docNro" name ="selectedDocNro" maxlength="50" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.docNro.errors && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)}"/>
          <mat-error  class="text-danger"*ngIf="registerFormControl.docNro.errors?.required && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)">
              El Nro. Documento es Requerido
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label font-bold" for="fechaEmision">Fecha Emisión</label>
          <div>
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fechaEmision" dateFormat="dd/mm/yy" inputId="fechaEmision" ngDefaultControl></p-calendar>
            <div *ngIf="registerFormControl.fechaEmision.errors?.required && (registerFormControl.fechaEmision?.dirty || registerFormControl.fechaEmision?.touched)" class="text-danger">La Fecha es Requerida</div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="col-form-label font-bold" for="fechaValidez">Fecha Validez</label>
          <div>
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fechaValidez" dateFormat="dd/mm/yy" inputId="fechaValidez" ngDefaultControl></p-calendar>
            <div *ngIf="registerFormControl.fechaValidez.errors?.required && (registerFormControl.fechaValidez?.dirty || registerFormControl.fechaValidez?.touched || submitted)" class="text-danger">La Fecha es Requerida</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class=" col-form-label font-bold">Lugar Emisión</label>
          <input formControlName="lugarEmision" name ="selectedlugarEmision" maxlength="50" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.lugarEmision.errors && (registerFormControl.lugarEmision?.dirty || registerFormControl.lugarEmision?.touched || submitted)}"/>
          <mat-error  class="text-danger"*ngIf="registerFormControl.lugarEmision.errors?.required && (registerFormControl.lugarEmision?.dirty || registerFormControl.lugarEmision?.touched || submitted)">
              El Lugar Emisión es Requerido
          </mat-error>
        </div>
        <div class="col-md-6">
          <label class="col-form-label font-bold">País</label>
          <comboTools [list]=paisesList
                      selected='paisEmisor'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='País'></comboTools>
          <div *ngIf="registerFormControl.paisEmisor.invalid && (
              registerFormControl.paisEmisor?.dirty || registerFormControl.paisEmisor?.touched || submitted)" class="text-danger">
            El País es Requerido
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class=" col-form-label font-bold">Nro. Emisión</label>
          <input formControlName="nroEmision" name ="selectednroEmision" maxlength="50" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.nroEmision.errors && (registerFormControl.nroEmision?.dirty || registerFormControl.nroEmision?.touched || submitted)}"/>
          <mat-error  class="text-danger"*ngIf="registerFormControl.nroEmision.errors?.required && (registerFormControl.nroEmision?.dirty || registerFormControl.nroEmision?.touched || submitted)">
              El Nro. Emisión es Requerido
          </mat-error>
        </div>
        <div class="col-md-6">
          <label class=" col-form-label font-bold">Autoridad</label>
          <input formControlName="autoridad" name ="selectedAutoridad" maxlength="50" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.autoridad.errors && (registerFormControl.autoridad?.dirty || registerFormControl.autoridad?.touched || submitted)}"/>
          <mat-error  class="text-danger"*ngIf="registerFormControl.autoridad.errors?.required && (registerFormControl.autoridad?.dirty || registerFormControl.autoridad?.touched || submitted)">
              La Autoridad es Requerida
          </mat-error>
        </div>
      </div>
      
    </form>
  </div>
  
  